import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import WfsService from "../services/WfsService";

const useWfsService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new WfsService(client);
  }, [client]);

  return service;
};

export default useWfsService;
